import { genericGet } from "../../../services/api.service";
import { EntityConfig } from "../../../types/EntityConfig";



export const  PecasEntregaConfig : EntityConfig = [

    {
        id: 'id',
        label: 'Id',
        type: 'id',
        nonEditable: true
      },
      {
        id: 'peca',
        label: 'Peça',
        type: 'select',
        routable: true,
        filterable: true,
        options: {
          name: 'Peça',
          route: 'peca',
          value: 'id',
          label: 'reference',
          routeBasedGetter: async (obraId : number)=> {const response = await genericGet(`/obras/${obraId}/pecas`); return response.data}, 
          routeParams: [2], // Form parameter used to build getterfunction
          defaultOptions: [],
          searcheable: true
        }
      },
      {
        id: 'quantidade',
        label: 'Quantidade',
        type: 'number',
    },


]